import { useCallback, useMemo } from "react"
import PropTypes from "prop-types"
import { map, isFunction } from "lodash"
import { useDispatch } from "react-redux"
import { Creators } from "model/apiWrapper"
import { useAccountAlias } from "resources/account"
import { combineTanStackStatuses, OK } from "helpers/data-statuses"
import useCombinedQueries from "hooks/combine-queries"

export default function DataIntegrator({ metrics, Renderer, rendererProps, dataTransform }) {
  const dispatch = useDispatch()
  const account = useAccountAlias()
  const combine = useCallback(results => {
    const status = combineTanStackStatuses(results)
    const data = status === OK ? map(results, "data") : null
    return { status, data }
  }, [])

  const queries = map(metrics, ({ key, query, variables, select }) => ({
    queryKey: [key],
    queryFn: () => new Promise((resolve, reject) => {
      dispatch(Creators.graphql(account, query, variables, resolve, reject))
    }),
    select,
  }))

  const { status, data } = useCombinedQueries(queries, combine)
  const transformedData = useMemo(() => {
    if (status === OK && isFunction(dataTransform)) {
      return dataTransform(data)
    }
    return data
  }, [status, data, dataTransform])

  return <Renderer status={status} data={transformedData} {...rendererProps} />
}

DataIntegrator.propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
    query: PropTypes.string.isRequired,
    variables: PropTypes.object.isRequired,
    select: PropTypes.func.isRequired,
  })).isRequired,
  Renderer: PropTypes.func.isRequired,
  rendererProps: PropTypes.object,
  dataTransform: PropTypes.func,
}
